module.exports = __webpack_public_path__ + "img/jigsaw-back.30d9092f.png";